/* GCA-050-AB */
document.addEventListener('DOMContentLoaded', () => {
  const SECTION_ID = 'gca-050-cart-drawer-upgrades';
  const REBUY_ROOT = '#rebuy-cart';
  const INJECTED_SELECTOR = '[data-gca-050-upgrades][data-gca-050-rebuy]';
  let refreshTimer;
  let refreshRequestId = 0;

  function waitForRebuy(callback) {
    const maxWaitTime = 10000;
    const interval = 50;
    let elapsedTime = 0;

    const waitingInterval = setInterval(() => {
      if (document.querySelector(REBUY_ROOT)) {
        callback();
        clearInterval(waitingInterval);
        return;
      }

      elapsedTime += interval;
      if (elapsedTime >= maxWaitTime) {
        clearInterval(waitingInterval);
      }
    }, interval);
  }

  function getSectionUrl() {
    const root = `${window.Shopify?.routes?.root || '/'}`;
    const path = root.endsWith('/') ? root.slice(0, -1) : root;
    return `${path}/cart?sections=${SECTION_ID}&_=${Date.now()}`;
  }

  function getCartUrl() {
    const root = `${window.Shopify?.routes?.root || '/'}`;
    const path = root.endsWith('/') ? root.slice(0, -1) : root;
    return `${path}/cart.js`;
  }

  function getInjectionTarget() {
    return (
      document.querySelector('.rebuy-cart__flyout-items') ||
      document.querySelector('.rebuy-cart__flyout-body') ||
      document.querySelector('.rebuy-cart__flyout-subtotal')
    );
  }

  function showAddedState(variantId) {
    if (!variantId) return;

    document.querySelectorAll('[data-gca-050-atc]').forEach((button) => {
      const form = button.closest('form');
      const input = form?.querySelector('[name="id"]');
      if (!input || input.value !== String(variantId)) return;

      button.classList.remove('loading', 'gca-050-cart-upgrades__atc--loading');
      button.classList.add('gca-050-cart-upgrades__atc--added');
      button.setAttribute('aria-disabled', 'true');
      button.disabled = true;

      const label = button.querySelector('[data-gca-050-atc-label]');
      const added = button.querySelector('[data-gca-050-atc-added]');
      const spinner = button.querySelector('.loading-overlay__spinner');

      if (label) label.setAttribute('hidden', '');
      if (added) added.removeAttribute('hidden');
      if (spinner) spinner.classList.add('hidden');
    });
  }

  function initUpgradesSlider(root) {
    const track = root.querySelector('.gca-050-cart-upgrades__track');
    const prevButton = root.querySelector('[data-gca-050-scroll="prev"]');
    const nextButton = root.querySelector('[data-gca-050-scroll="next"]');

    if (!track || !prevButton || !nextButton) return;

    const getScrollStep = () => {
      const slide = track.querySelector('.gca-050-cart-upgrades__slide');
      if (!slide) return track.clientWidth;

      const trackStyles = window.getComputedStyle(track);
      const gap = parseFloat(trackStyles.columnGap || trackStyles.gap) || 10;

      return slide.offsetWidth + gap;
    };

    const updateButtons = () => {
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      const hasOverflow = maxScroll > 2;
      const atStart = track.scrollLeft < 2;
      const atEnd = track.scrollLeft > maxScroll - 2;

      const prevActive = hasOverflow && !atStart;
      const nextActive = hasOverflow && !atEnd;

      prevButton.classList.toggle('gca-050-cart-upgrades__arrow--active', prevActive);
      nextButton.classList.toggle('gca-050-cart-upgrades__arrow--active', nextActive);

      prevButton.disabled = !prevActive;
      nextButton.disabled = !nextActive;
      prevButton.setAttribute('aria-hidden', prevActive ? 'false' : 'true');
      nextButton.setAttribute('aria-hidden', nextActive ? 'false' : 'true');
    };

    const scrollTrack = (direction) => {
      const distance = direction === 'next' ? getScrollStep() : -getScrollStep();

      track.scrollBy({
        left: distance,
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      });
    };

    if (root.dataset.gca050SliderBound === 'true') {
      track.scrollLeft = 0;
      window.requestAnimationFrame(updateButtons);
      window.setTimeout(updateButtons, 150);
      return;
    }

    root.dataset.gca050SliderBound = 'true';

    track.scrollLeft = 0;

    prevButton.addEventListener('click', () => scrollTrack('prev'));
    nextButton.addEventListener('click', () => scrollTrack('next'));
    track.addEventListener('scroll', updateButtons, { passive: true });

    track.querySelectorAll('img').forEach((image) => {
      if (!image.complete) {
        image.addEventListener('load', updateButtons, { once: true });
      }
    });

    if (typeof ResizeObserver !== 'undefined') {
      const resizeObserver = new ResizeObserver(updateButtons);
      resizeObserver.observe(track);
    }

    window.requestAnimationFrame(updateButtons);
    window.setTimeout(updateButtons, 150);
    window.setTimeout(updateButtons, 500);
    window.setTimeout(updateButtons, 1000);
  }

  function bindUpgradesModule(root) {
    if (!root) return;

    initUpgradesSlider(root);

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && !root.dataset.gca050CartBound) {
      root.dataset.gca050CartBound = 'true';

      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event.source !== 'product-form') return;
        if (!event.productVariantId) return;
        if (!root.querySelector(`[name="id"][value="${event.productVariantId}"]`)) return;

        setTimeout(() => {
          showAddedState(event.productVariantId);
        }, 50);
      });
    }
  }

  function removeUpgradesModule() {
    document.querySelectorAll(INJECTED_SELECTOR).forEach((node) => node.remove());
  }

  function mountUpgrades(node) {
    const target = getInjectionTarget();
    if (!target || !node) return false;

    node.setAttribute('data-gca-050-rebuy', '');

    removeUpgradesModule();

    if (target.matches('.rebuy-cart__flyout-items')) {
      target.insertAdjacentElement('afterend', node);
    } else if (target.matches('.rebuy-cart__flyout-subtotal')) {
      target.insertAdjacentElement('beforebegin', node);
    } else {
      target.appendChild(node);
    }

    bindUpgradesModule(node);
    return true;
  }

  async function refreshUpgrades() {
    if (!document.querySelector(REBUY_ROOT)) return;

    const requestId = ++refreshRequestId;

    try {
      const cartResponse = await fetch(getCartUrl(), { credentials: 'same-origin', cache: 'no-store' });
      if (requestId !== refreshRequestId || !cartResponse.ok) return;

      const response = await fetch(getSectionUrl(), { credentials: 'same-origin', cache: 'no-store' });
      if (requestId !== refreshRequestId || !response.ok) return;

      const data = await response.json();
      const sectionHtml = data[SECTION_ID];
      if (requestId !== refreshRequestId) return;

      removeUpgradesModule();

      if (!sectionHtml) return;

      const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
      const next = doc.querySelector('[data-gca-050-upgrades]');

      if (next) {
        mountUpgrades(next);
      }
    } catch (error) {
      console.error('GCA-050-AB: failed to refresh cart upgrades', error);
    }
  }

  function scheduleRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refreshUpgrades, 200);
  }

  function scheduleRefreshAfterCartChange() {
    scheduleRefresh();
    setTimeout(refreshUpgrades, 600);
  }

  function bindRebuyObserver() {
    const rebuyRoot = document.querySelector(REBUY_ROOT);
    if (!rebuyRoot || rebuyRoot.dataset.gca050Bound === 'true') return;

    rebuyRoot.dataset.gca050Bound = 'true';

    const observer = new MutationObserver(() => {
      if (!document.querySelector(INJECTED_SELECTOR)) {
        scheduleRefresh();
      }
    });

    observer.observe(rebuyRoot, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });
  }

  function bindCartEvents() {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event.source === 'gca-050-cart-upgrades') return;
        scheduleRefreshAfterCartChange();
      });
    }

    document.addEventListener('cart:updated', scheduleRefreshAfterCartChange);
    document.addEventListener('cart:refresh', scheduleRefreshAfterCartChange);
    document.addEventListener('rebuy:cart.change', scheduleRefreshAfterCartChange);
    document.addEventListener('rebuy:cart:change', scheduleRefreshAfterCartChange);
    document.addEventListener('rebuy:smartcart.show', scheduleRefresh);
    document.addEventListener('rebuy:smartcart.line-item-removed', scheduleRefreshAfterCartChange);
    document.addEventListener('rebuy:smartcart.line-item-decrease', scheduleRefreshAfterCartChange);
  }

  waitForRebuy(() => {
    bindRebuyObserver();
    bindCartEvents();
    scheduleRefresh();
  });
});
